import { render } from "./CompaniesPage.vue?vue&type=template&id=c4a68d3e"
import script from "./CompaniesPage.vue?vue&type=script&lang=js"
export * from "./CompaniesPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__